export default [{
        path: '/notices',
        name: 'notices',
        component: () =>
            import ('@/views/modules/notices/notices-list/NoticesList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Anuncios',
            breadcrumb: [{
                text: 'Lista de anuncios',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/notice/create',
        name: 'notices-create',
        component: () =>
            import ('@/views/modules/notices/notices-store/NoticeStore.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Anuncios',
            breadcrumb: [{
                text: 'Lista de anuncios',
                to: { name: 'notices' }
            }, {
                text: 'Nuevo anuncio',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/notice/:id/edit',
        name: 'notices-edit',
        component: () =>
            import ('@/views/modules/notices/notices-edit/NoticesEdit.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Anuncios',
            breadcrumb: [{
                text: 'Lista de anuncios',
                to: { name: 'notices' }
            }, {
                text: 'Editar anuncio',
                active: true
            }],
            requiresAuth: true
        }
    }
]